$(document).ready(function(){
  $('.container-faqs-questions').hide();
  $('.main-faqs-buttons button').first().addClass('active-button');
  var $sf = '.container-faqs-questions .link-' + $('.main-faqs-buttons button').first().data('link');
  var $f = $($sf).parent('.container-faqs-questions');
  $($f).show();
  $('.accordion-faqs > .accordion-faqs__item > .accordion-faqs__answer').hide();


  $('.main-faqs-actions__items').click(function() {
    var $selectorFaq = '.container-faqs-questions .link-' + $(this).data('link');
    var $faq = $($selectorFaq).parent('.container-faqs-questions');
    $('.main-faqs-buttons button').removeClass('active-button');
    $('.main-faqs-buttons .button-' + $(this).data('link')).addClass('active-button');
    $('.container-faqs-questions').hide();
    $($faq).show();
    var $heightNav = $('.main_top_header').height();
    $("html, body").animate({ scrollTop: $(".container-faqs-button").offset().top - ($heightNav + 20) }, "slow");
    return false;
  });

  $('.main-faqs-buttons button').click(function() {
    var $selectorFaq = '.container-faqs-questions .link-' + $(this).data('link');
    var $faq = $($selectorFaq).parent('.container-faqs-questions');
    $('.main-faqs-buttons button').removeClass('active-button');
    $('.main-faqs-buttons .button-' + $(this).data('link')).addClass('active-button');
    $('.container-faqs-questions').hide();
    $($faq).show();
  });
    
  $('.accordion-faqs > .accordion-faqs__item').click(function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active").find(".accordion-faqs__answer").slideUp();
    } else {
      $(".accordion-faqs > .accordion-faqs__item.active .accordion-faqs__answer").slideUp();
      $(".accordion-faqs > .accordion-faqs__item.active").removeClass("active");
      $(this).addClass("active").find(".accordion-faqs__answer").slideDown();
    }
    return false;
  });
  
});